import { createRoute } from '@tanstack/react-router';

import { authenticatedLayout } from '@/app/router/layout';

import { promosQueryOptions } from './api';

const promoListRoute = createRoute({
  getParentRoute: () => authenticatedLayout,
  path: 'promotions',
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(promosQueryOptions()),
}).lazy(() => import('./PromoList').then((d) => d.Route));

export const promoRoute = promoListRoute;
